import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addReturnCredent from "./components/addReturnCredent";
import { getAdCallbackTokens, deleteAdCallbackToken } from "@/api/financial/backhaul";
import { serchSelect, serchSelectManage } from "@/mixins/index";
import backhaul from "./mixins/backhaul";
export default {
  name: "returnCredentialMement",
  mixins: [backhaul, serchSelect, serchSelectManage],
  components: {
    addReturnCredent: addReturnCredent
  },
  data: function data() {
    return {
      tableData: [],
      reqLoading: false
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.searchData.page = e;
      this.reqLoading = true;
      getAdCallbackTokens(_objectSpread(_objectSpread({}, this.searchData), {}, {
        game_id: this.searchData.game_id
      })).then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;

      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                deleteAdCallbackToken({
                  product: row.product,
                  game_id: _this2.searchData.game_id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this2.searchClick();

                    _this2.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};